import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';
import type { RequisitionsParams } from '@recruitee/requisitions-types';

import { RequisitionsSelectors } from './requisitions.store';
import type { RequisitionsGroupedParams, RequisitionsGroupEntity } from './requisitions.types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<RequisitionsGroupEntity>()('RequisitionsGrouped', {
    idSelector: entity => entity.name || '', // one group name can be null, so we select it by empty string
    references: makeRef => [
      makeRef('requisitionIds', 'requisitions', RequisitionsSelectors.byIdsWithReferences),
    ],
    customActions: adapter => ({
      fetchCollection: (state, payload: RequisitionsGroupedParams) =>
        adapter.markAsPending(state, { scope: payload.scope, entities: [] }),
    }),
  });

const RequisitionsGroupedActions = {
  fetchCollection: actions.fetchCollection,
  fetchCollectionSuccess: actions.fetchCollectionSuccess,
  fetchCollectionFailed: actions.fetchCollectionFailed,
};

const RequisitionsGroupedSelectors = {
  ...selectors,
  entitiesWithReferences: memoizeSelector((params: RequisitionsParams) =>
    createSelector(selectors.entitiesWithReferences(params), entities =>
      entities.map(group => ({
        ...group,
        requisitions: group.requisitions || [],
      })),
    ),
  ),
};

export {
  RequisitionsGroupedActions,
  RequisitionsGroupedSelectors,
  reducer as RequisitionsGroupedReducer,
  namespace as RequisitionsGroupedNamespace,
};
